export const NODE_ENV = process.env.NODE_ENV;
export const KEYCLOAK_CLIENT_ID = process.env.KEYCLOAK_CLIENT_ID || 'rs-portal-email';
export const API_PREFIX = NODE_ENV === 'production' ? 'https://api.readyspaces.com' : 'https://dev.api.readyspaces.com';

export const ORIGIN = NODE_ENV === 'production' ? 'https://epoch.readyspaces.com' : 'https://portal.api.readyspaces.com';
export const CRM = NODE_ENV === 'production' ? 'https://members.readyspaces.com' : 'https://crm.api.readyspaces.com';
export const SSO_API_BASE = NODE_ENV === 'production' ? 'https://sso.readyspaces.com/' : 'https://dev.sso.api.readyspaces.com/auth';

export const CUSTOMER_API_BASE = `${API_PREFIX}`;
export const isDevelopment = CUSTOMER_API_BASE.startsWith('https://dev');
export const AUTH_API_BASE = `${API_PREFIX}/auth/private`;
export const PG_API_BASE = `${API_PREFIX}/pg/api/v1`;
export const EMAIL_API_BASE = `${API_PREFIX}/emails/v1`;
export const ADMIN_API_BASE = `${API_PREFIX}/admin/api/v1`;
export const RISKS_API_BASE = `${API_PREFIX}/admin/api/risks`;
export const ACCRUAL_API_BASE = `${API_PREFIX}/admin/api/accrual/v1`;
export const FACILITY_ACCOUNT_API_BASE = `${API_PREFIX}/admin/api/facility-account`;
export const FACILITY_TRANSACTIONS_API_BASE = `${API_PREFIX}/admin/api/facility-transactions`;
export const UNITS_API_BASE = `${API_PREFIX}/admin/api/units/v1`;
export const UNIT_RENTAL_API_BASE = `${API_PREFIX}/admin/api/unit-rental/v1`;
export const UNIT_RENTAL_API_V1_1 = `${API_PREFIX}/admin/api/unit-rental/v1.1`;
export const UNIT_RENTAL_API_V2 = `${API_PREFIX}/admin/api/unit-rental/v2`;
export const UNIT_RENTAL_API_V2_1 = `${API_PREFIX}/admin/api/unit-rental/v2.1`;
export const UNITS_API_BASE_V2 = `${API_PREFIX}/admin/api/units/v2`;
export const SITEMAP_API = facilityId => `${API_PREFIX}/admin/api/sitemap/v1/${facilityId}`;
export const SITEMAP_API_UPDATE = `${API_PREFIX}/admin/api/sitemap/v1/update`;
export const ORG_API_UPDATE = `${API_PREFIX}/admin/api/org/v1/theme/616ec7f131128987b980d47d`;
export const ORG_API_PRICING = `${API_PREFIX}/admin/api/org/v1/pricing/616ec7f131128987b980d47d`;
export const ORG_API_ACHFEE = `${API_PREFIX}/admin/api/org/v1/achfee/616ec7f131128987b980d47d`;
export const ORG_API = `${API_PREFIX}/admin/api/org/v1/616ec7f131128987b980d47d`;
export const UPLOAD_API = `${API_PREFIX}/uploader/private/upload`;
export const LEASING_API = `${API_PREFIX}/admin/api/leasing`;
export const LEASE_TRANSFER_API = `${API_PREFIX}/admin/api/lease/transfer`;
export const RS_ANVIL_API = `${API_PREFIX}/anvil/api`;
export const ANVIL_TEMPLATE_ID = '7uVg8NT6CtphULPqSIv2';
export const ANVIL_TEMPLATE_ID2 = 'bT01QWCvygVGROwkr8Q1';
export const CC_TEMPLATE_ID = 'aCKbJNpwh4CiZrtB9X8P';
export const NON_RENEWAL_TEMPLATE_ID = '9OW7h0mjCz9c0GKrUvTp';
export const PRELIEN_TEMPLATE_ID = 'RrQ6LmaFg7M4ejDQZAU8';
export const LIEN_TEMPLATE_ID = 'LUqJNNDgsnRXWwvYFZaH';
export const CUSTOMER_ADMIN_API_BASE = `${API_PREFIX}/admin/api/customers/v1`;
export const GLOBAL_AVAILABILITY_API_BASE = `${API_PREFIX}/admin/api/global/availability`;
export const WORKFLOW_API_BASE = `${API_PREFIX}/admin/api/workflow`;
export const WALLET_TRANSACTIONS_API_BASE = `${API_PREFIX}/admin/api/wallet-transactions`;
export const REFUND_REQUEST_API_BASE = `${API_PREFIX}/admin/api/refund-request`;
export const FEDEX_API = `${API_PREFIX}/admin/api/fedex/v1`;
export const AUDIT_API = `${API_PREFIX}/admin/api/audit/v1`;
export const ORG_API_FEE_TYPES = `${API_PREFIX}/admin/api/org/v1/fees/616ec7f131128987b980d47d`;
export const SITEMAP_API_V2_IMPORT = facilityId => `${API_PREFIX}/admin/api/sitemap/v2/facility/${facilityId}/import`;
export const SITEMAP_API_V2_IMPORT_STATUS = facilityId => `${API_PREFIX}/admin/api/sitemap/v2/facility/${facilityId}/import-status`;
export const SITEMAP_API_V2_SCENE = facilityId => `${API_PREFIX}/admin/api/sitemap/v2/facility/${facilityId}/scene`;
export const SITEMAP_API_V2_VIEWPORT = facilityId => `${API_PREFIX}/admin/api/sitemap/v2/facility/${facilityId}/viewport`;
export const UNITS_API_V2_SITE_PLAN = unitId => `${API_PREFIX}/admin/api/units/v2/unit/${unitId}/site-plan`;
export const UNITS_API_V2_BULK_SITE_PLAN = facilityId => `${API_PREFIX}/admin/api/units/v2/facility/${facilityId}/site-plan/units`;
export const TINYMCE_API_KEY = 'isy4tdvpvqzvpglhlujiryiytz4phrzl5i4ywuj2y1at4bgl';



// WEBPACK FOOTER //
// ./src/env.js